var _style, _line, _line2, _g, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraph4PillarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14400 14400",
    style: {
      enableBackground: "new 0 0 14400 14400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:50;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:34;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:34;stroke-miterlimit:10;stroke-dasharray:51.1916,51.1916;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6430,
    y1: 6772.8,
    x2: 6430,
    y2: 7629.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7884.8,
    y1: 7627.4,
    x2: 6430,
    y2: 7627.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7864.5,
    y1: 6984.1,
    x2: 7839.5,
    y2: 6984.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 7788.3,
    y1: 6984.1,
    x2: 6482.9,
    y2: 6984.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 6457.3,
    y1: 6984.1,
    x2: 6432.3,
    y2: 6984.1
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "7884.8,6936.7 7592.2,7068.2 7317.5,7028.2 7024,7183.2 6732.8,7086.9 6432.3,7301.8 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph4PillarIcon);
export default __webpack_public_path__ + "static/media/Graph_4pillar_icon.3d3a5c76f303b8e86fff610d2a37af32.svg";
export { ForwardRef as ReactComponent };